const cache = new Map();

/**
 * In-memory caching and request deduplication wrapper for API calls.
 * @param {string} key - Unique cache key
 * @param {Function} fetcher - Async function returning axios Promise
 * @param {number} ttlMs - Time to live in ms (default 2 minutes)
 */
export function cachedGet(key, fetcher, ttlMs = 120000) {
  const now = Date.now();
  const cached = cache.get(key);

  if (cached && cached.data && now - cached.timestamp < ttlMs) {
    return Promise.resolve(cached.data);
  }

  if (cached && cached.promise) {
    return cached.promise;
  }

  const promise = fetcher()
    .then((res) => {
      cache.set(key, { data: res, timestamp: Date.now() });
      return res;
    })
    .catch((err) => {
      cache.delete(key);
      throw err;
    });

  cache.set(key, { promise, timestamp: now });
  return promise;
}

/**
 * Clear cached items by prefix or completely.
 * @param {string} [keyPrefix]
 */
export function clearCache(keyPrefix) {
  if (!keyPrefix) {
    cache.clear();
    return;
  }
  for (const k of cache.keys()) {
    if (k.startsWith(keyPrefix)) {
      cache.delete(k);
    }
  }
}

export default {
  cachedGet,
  clearCache,
};
